import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getCourseLearningActions } from "../slices";
import { SECTION_ITEM_TYPE } from "@constants";

export const filterLessonValid = (sections) => {
  if (!sections || sections.length == 0) {
    return [];
  }
  return sections
    .filter((section) => section.isDeleted !== true)
    .map((section) => {
      const newLessons = [
        ...section.lectures.map((l) => ({
          ...l,
          type: SECTION_ITEM_TYPE.LECTURE,
        })),
        ...section.quizzes.map((l) => ({
          ...l,
          type: SECTION_ITEM_TYPE.QUIZ,
        })),
        ...section.assignments.map((l) => ({
          ...l,
          type: SECTION_ITEM_TYPE.ASSIGNMENT,
        })),
      ]
        .filter((lesson) => lesson.isDeleted !== true)
        .sort((a, b) => a.index - b.index);
      return { ...section, lessons: newLessons };
    });
};

function* getCourseLearningWorker({ payload }) {
  try {
    yield put(getCourseLearningActions.pending());
    const response = yield call(courseAPI.getCourseForLearning, payload);
    const { data } = response;
    const sectionsMapped = filterLessonValid(data.sections);
    const newPayload = {
      ...response,
      data: { ...data, sections: sectionsMapped },
    };
    yield put(getCourseLearningActions.success(newPayload));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getCourseLearningActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getCourseLearningWorker };
